/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createTrue } from '../../factoriesAny.js';
export var trueDependencies = {
  createTrue
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesTrue.generated.js
// module id = null
// module chunks = 